import { useWidgetStore } from "../store/widget-store";
import { TabBar } from "./TabBar";
import { ChatTab } from "./chat/ChatTab";
import { ShopTab } from "./shop/ShopTab";

export function Panel() {
  const toggleOpen = useWidgetStore((state) => state.toggleOpen);
  const activeTab = useWidgetStore((state) => state.activeTab);
  const config = useWidgetStore((state) => state.config);

  return (
    <div className="flex h-[600px] w-[380px] flex-col overflow-hidden rounded-2xl bg-white shadow-2xl">
      <div className="flex items-center justify-between bg-brand px-4 py-3 text-white">
        <div>
          <p className="text-sm font-semibold">
            {config?.organizationName ?? "Chat with us"}
          </p>
          {config?.welcomeMessage ? (
            <p className="text-xs text-white/80">{config.welcomeMessage}</p>
          ) : null}
        </div>
        <button
          type="button"
          onClick={toggleOpen}
          aria-label="Close chat"
          className="rounded-full p-1 text-white/80 hover:bg-white/10 hover:text-white"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            className="h-5 w-5"
          >
            <path d="M18 6 6 18M6 6l12 12" />
          </svg>
        </button>
      </div>

      <TabBar />

      <div className="flex flex-1 flex-col overflow-hidden">
        {activeTab === "chat" ? <ChatTab /> : <ShopTab />}
      </div>
    </div>
  );
}
